import { VideoData } from "@/redux/feature/videoDashboard/videoDashboardType";
import { useState } from "react";
import LoadingMessage from "../LoadingMessage";
import ProductCard from "../ProductCard";
import { CustomButton } from "@/components/ui/Buttons";

const VideoSection = ({
  title,
  icon,
  videos,
  isLoading,
  isProcessing,
  currentlyPlaying,
  setCurrentlyPlaying,
  setIsDetailsModalOpen,
  setSelectedVideo,
}: {
  title: string;
  icon: React.ReactNode;
  videos: VideoData[];
  isLoading: boolean;
  isProcessing?: boolean;
  currentlyPlaying: string | null;
  setIsDetailsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setCurrentlyPlaying: React.Dispatch<React.SetStateAction<string | null>>;
  setSelectedVideo?: React.Dispatch<React.SetStateAction<VideoData | null>>;
}) => {
  return (
    <div className="mt-8 sm:mt-10">
      <div className="flex items-center gap-x-2">
        <span className="flex-shrink-0">{icon}</span>
        <h3 className="text-black text-lg font-medium flex-1">{title}</h3>
      </div>

      {isLoading ? (
        <LoadingMessage />
      ) : videos?.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-4">
          {videos.map((video) => (
            <ProductCard
              key={video.id}
              video={video}
              currentlyPlaying={currentlyPlaying}
              setCurrentlyPlaying={setCurrentlyPlaying}
              setIsDetailsModalOpen={setIsDetailsModalOpen}
              setSelectedVideo={setSelectedVideo}
            />
          ))}
        </div>
      ) : isProcessing ? (
        <LoadingMessage />
      ) : (
        <div className="py-6 text-center">
          <p className="font-medium text-sm text-gray-600">No videos found</p>
        </div>
      )}
    </div>
  );
};

export default VideoSection;
